import { render, staticRenderFns } from "./AddressTable.vue?vue&type=template&id=7cc5a606"
import script from "./AddressTable.vue?vue&type=script&lang=ts"
export * from "./AddressTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports